<section class="content-section">
  <div class="hero-panel">
    <div class="hero-main">
      <p class="hero-kicker">Suivi livreur</p>
      <h2>Livraisons du livreur</h2>
      <p class="hero-sub" *ngIf="nomLivreur">Historique de {{ nomLivreur }}</p>
      <p class="hero-sub" *ngIf="!nomLivreur">Historique du livreur #{{ livreurId }}</p>
    </div>
    <div class="hero-stats">
      <div class="stat-card">
        <span>Total</span>
        <strong>{{ totalElements }}</strong>
      </div>
      <div class="stat-card">
        <span>Page</span>
        <strong>{{ pageCourante }}/{{ totalPages }}</strong>
      </div>
    </div>
  </div>

  <div class="section-header">
    <div></div>
    <div class="header-actions">
      <button type="button" class="btn btn-primary" (click)="appliquerFiltres()">Actualiser</button>
      <a [routerLink]="'/utilisateur/enregistrerutilisateur/' + livreurId" class="btn btn-secondary">Retour fiche utilisateur</a>
    </div>
  </div>

  <div class="filters-card">
    <div class="filter-group">
      <label>Statut</label>
      <select [(ngModel)]="statutSelectionne" class="form-select">
        <option *ngFor="let s of statuts" [value]="s.value">{{ s.label }}</option>
      </select>
    </div>
    <div class="filter-group">
      <label>Date début</label>
      <input type="date" [(ngModel)]="dateDebut" class="form-input">
    </div>
    <div class="filter-group">
      <label>Date fin</label>
      <input type="date" [(ngModel)]="dateFin" class="form-input">
    </div>
    <div class="filter-actions">
      <button type="button" class="btn btn-primary" (click)="appliquerFiltres()">Filtrer</button>
      <button type="button" class="btn btn-secondary" (click)="reinitialiserFiltres()">Réinitialiser</button>
    </div>
  </div>

  <div *ngIf="messageErreur" class="error-banner">{{ messageErreur }}</div>
  <div *ngIf="indicateurChargement" class="loading-container">Chargement des livraisons...</div>

  <div *ngIf="!indicateurChargement && livraisons.length > 0" class="table-card">
    <div class="entries-info">
      Affichage de {{ indexDebut }} à {{ indexFin }} sur {{ totalElements }} livraison(s)
    </div>
    <div class="table-wrapper">
      <table class="commandes-table">
        <thead>
          <tr>
            <th>N° commande</th>
            <th>Client</th>
            <th>Statut</th>
            <th>Date création</th>
            <th>Date livraison</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let livraison of livraisons">
            <td class="ref-cell">{{ livraison.numeroCommande || livraison.numeroSuivi || ('#' + livraison.id) }}</td>
            <td>{{ livraison.clientNom || '—' }}</td>
            <td>
              <span class="status-badge" [ngClass]="obtenirClasseStatut(livraison.statut)">
                {{ obtenirTexteStatut(livraison.statut) }}
              </span>
            </td>
            <td>{{ livraison.dateCreation ? (livraison.dateCreation | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
            <td>{{ livraison.dateLivraison ? (livraison.dateLivraison | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
            <td>
              <button type="button" class="btn-view" (click)="voirDetailLivraison(livraison)">
                Voir détail
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-container">
      <button class="pagination-btn" [disabled]="pageCourante === 1" (click)="allerALaPage(1)">&laquo;</button>
      <button class="pagination-btn" [disabled]="pageCourante === 1" (click)="allerALaPage(pageCourante - 1)">&lsaquo;</button>
      <span class="page-label">Page {{ pageCourante }} / {{ totalPages }}</span>
      <button class="pagination-btn" [disabled]="pageCourante === totalPages" (click)="allerALaPage(pageCourante + 1)">&rsaquo;</button>
      <button class="pagination-btn" [disabled]="pageCourante === totalPages" (click)="allerALaPage(totalPages)">&raquo;</button>
    </div>
  </div>

  <div *ngIf="!indicateurChargement && livraisons.length === 0" class="no-results">
    Aucune livraison trouvée avec ces filtres.
  </div>
</section>

